import React, {useEffect, useState} from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { Typography, DatePicker, Modal, Table, Form, TimePicker, TreeSelect, Row, Col, Input, Tabs, Menu, Badge, Space, Select } from "antd";
import {openNotificationWithIcon, capitalizeFirstWord, errorHandle, generateArrWeekAndDays, getDateRange} from "../../Function";
import moment from "moment";
import { useSelector } from "react-redux";
import {CloseOutlined, DoubleLeftOutlined, DoubleRightOutlined, CheckOutlined
} from "@ant-design/icons";
import {changeStatusCCHRApi, nhanSuChiTietCongApi} from "../../../api/getChamcong";
import { ListBoPhanApi } from "../../../api/getListTeam";
import {lichSuChamCongApi, lichSuChinhSuaApi} from "../../../api/getLichSuChamCong";
import { BsFillSquareFill } from "react-icons/bs"; //npm i react-icons
import { LichLeTetApi } from "../../../api/getKhaiBao";

const { Text } = Typography;


// const dataLichSuEdit = [
//     {
//         "id": 1,
//         "nguoiSua": "admin",
//         "thoiGianCN": "2022-04-11 09:00:00",
//         "ghiChu": '1',
//         "gioVao": ['08:15', '08:00'],
//         "gioRa": ['17:15', '17:30'],

//     },
//     {
//         "id": 2,
//         "nguoiSua": "admin",
//         "thoiGianCN": "2022-04-11 10:00:00",
//         "ghiChu": 'abc',
//         "gioVao": ['08:15', ''],
//         "gioRa": ['17:15', '17:30'],
//     },
//     {
//         "id": 3,
//         "nguoiSua": "admin",
//         "thoiGianCN": "2022-04-12 11:00:00",
//         "ghiChu": 'a123',
//         "gioVao": ['08:15', '08:00'],
//         "gioRa": ['17:15', ''],
//     },
// ]

// const dataLichSuChamCong = [{ngay:"2022-04-11",time:'09:00',thietbi:"Abc"},{ngay:"2022-04-12",time:'10:00',thietbi:"Abc"},{ngay:"2022-04-12",time:'11:00',thietbi:"Abc"}];


const { Title } = Typography;

const getHeader = (data, date, isHoliday, currentSelectedDate)=>{
    return <span style={{color:isHoliday ? 'red' : ''}}>{new Date(data).getDay() === 0 ? "CN" : "Thứ " + (new Date(data).getDay() + 1)}<br/>
       {currentSelectedDate.month() == moment(data).month() ?
            moment(data).format('DD/MM/YYYY') : ""
        }
        </span>
}

const getClassColor = (type) =>{
    let result;
    switch (type) {
        case 'Done':
            result = 'timekeeper-undefined';
            break;
        case 'Processing':
            result = 'timekeeper-undefined';
            break;
        case 'Error':
            result = 'timekeeper-error';
            break;
        default:
            result = '';
            break;
        // default: result = date <= new Date() ? 'timekeeper-future' : 'timekeeper-undefined';break;
    }
    return result || '';
}

const RenderItemRow = (text,record,updateData,currentDate,setIsShowDetailItem, setCurrentItem,setCurrentDateSelected)=>{
    return (
        <>
            <div style={{textAlign:'center',width:'100%'}}>
                {text ?
                <RenderSingleInnerItem record={record} text={text} currentDate={currentDate} setIsShowDetailItem={setIsShowDetailItem} setCurrentItem={setCurrentItem} setCurrentDateSelected={setCurrentDateSelected}/>
                :
                "-"}
            </div>
        </>
    )
}

const RenderSingleInnerItem =({record,text,currentDate,setIsShowDetailItem,setCurrentItem,setCurrentDateSelected})=>{
    const onShowDetailItem =()=>{
        setCurrentDateSelected(currentDate);
        setCurrentItem(record);
        setIsShowDetailItem(true);
    }
    const getText =(text)=>{
        let result;
        switch (text.type) {
            case 'Success':
                result = text.soGioCong === 0 ? "-" : text.soGioCong + text.cheDo;break;
            case 'Error':
                result = text.ghiChu;break;
            case 'offDate':
                result = '-';break;
            case 'Processing':
                let convertGioVao = text.gioVao ? text.gioVao.toString().substr(0,5) : "";
                let convertGioRa = text.gioRa ? text.gioRa.toString().substr(0,5) : "";
                result = convertGioVao + " - " + convertGioRa;
                break;
            default:
                result = '';break;
        }
        if (text.loaiChamcongChitiet !== '' && text.loaiChamcongChitiet !== null) {
            result += "(" + text.soGioCD + "h- " + text.loaiChamcongChitiet + ")"
        }
        return result;
    }
    return <>
        <div onClick={text.type !== 'offDate' ? onShowDetailItem : null}>
            {getText(text)}
        </div>

    </>
}


const ModalDetailItem = ({visible,onCancel,itemDetail,currentDate,updateData})=>{
    const [form] = Form.useForm();
    const [dataLs, setDataLs] = useState([]);
    const [dataLsCC, setDataLsCC] = useState([]);
    const [activeKey, setActiveKey] = useState('1');
    const [isEditing,setIsEditing] = useState(false);
    const [timeStart, setTimeStart] = useState(itemDetail['col'+currentDate] ? moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioVao,"YYYYMMDDHH:mm") : null);
    const [timeEnd, setTimeEnd] = useState(itemDetail['col'+currentDate] ? moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioRa,"YYYYMMDDHH:mm") : null);

    useEffect(()=>{
        itemDetail.hasOwnProperty('col'+currentDate) &&
            form.setFieldsValue({
                ngay: moment(itemDetail['col'+currentDate].ngay,'YYYY-MM-DD').format('DD/MM/YYYY').toString(),
                gioVao: itemDetail['col'+currentDate].gioVao,
                gioRa: itemDetail['col'+currentDate].gioRa,
                soGioCong: itemDetail['col'+currentDate].soGioCong,
                soCong: itemDetail['col'+currentDate].soCong,
                loaiCC: itemDetail['col'+currentDate].loaiChamCong
            })
        // itemDetail.hasOwnProperty('col'+currentDate) ? setLsDuAn(itemDetail['col'+currentDate].listDuan) : null;
    },[visible])

    const onEditing =()=>{
        setTimeEnd(moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioRa,"YYYYMMDDHH:mm"))
        setTimeStart(moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioVao,"YYYYMMDDHH:mm"))
        form.setFieldsValue({
            gioVao: moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioVao,"YYYYMMDDHH:mm"),
            gioRa: moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioRa,"YYYYMMDDHH:mm"),
        })
        setIsEditing(true);
    }

    const getDisableHourOutEdit = () => {
        const timeIn = timeStart ? timeStart._d.getHours() : 0
        let arrCheck = [...Array(24).keys()]
        return arrCheck.filter(item => item < timeIn)
    }

    const getDisableHourInEdit = () => {
        const timeIn = timeEnd ? timeEnd._d.getHours() : 24
        let arrCheck = [...Array(24).keys()]
        return arrCheck.filter(item => item > timeIn)
    }

    const onFinish = (values) => {
        // EditItemChamCongApi({
        //     listUser: values.member,
        //     ngay: getDaysArray_dmy(values.ngaydangky[0]._d,values.ngaydangky[1]._d),
        // })
        // .then(res=>{
        //     console.log(res);
        //     if (res.data.error) {
        //         // const dataError = Object.entries(res.data.error).map(([key,value]) => <p>{value}</p>)
        //         openNotificationWithIcon('error', res.data.error)
        //     } else {
        //         updateData();
        //         onCancel();
        //         form.resetFields();
        //     }

        // })
        // .catch(err=>{
        //     if (err.data.error) {
        //         // const dataError = Object.entries(res.data.error).map(([key,value]) => <p>{value}</p>)
        //         openNotificationWithIcon('error', err.data.error)
        //     }
        // });
        onCancel();
        setActiveKey('1')
    };

    const onCancelModal =()=>{
        // updateData();
        form.resetFields();
        setIsEditing(false);
        setActiveKey('1');
        onCancel();
    }

    const tailLayout = {
        wrapperCol: { offset: 10, span: 15 },
    };

    const viewHistoryEdit = (values) => {
        // Id bảng chấm công cá nhân
        if (itemDetail['col'+currentDate].ghiChu == "Không chấm công"){
            openNotificationWithIcon('error','Lỗi', 'Nhân viên chưa chấm công')
            return false
        }

        lichSuChinhSuaApi({id:itemDetail['col'+currentDate].id}).then(r=>{
            setDataLs(r.data);
            setActiveKey('3');
        })
    };

    const viewHistoryTimekeeping = (values) => {
        // Id của user
        lichSuChamCongApi({
            idUser:itemDetail.id,
            tuNgay: itemDetail['col'+currentDate].ngay,
            denNgay: itemDetail['col'+currentDate].ngay
        }).then(r=>{

            setDataLsCC(r.data);
            setActiveKey('2');
        })
    };

    const FormViewHistoryEdit = ({itemDetail})=>{
        const [loadingLs, setLoadingLs] = useState(false);
        const [pagerLs, setPagerLs] = useState({pageSize:10});

        const columns = [
            {
                title: "STT",
                dataIndex: "index",
                key: "index",
                align: 'center',
                render: (value, item, index) => ((pagerLs.current || 1) - 1) * pagerLs.pageSize + index + 1,
            },
            {
                title: "Người điều chỉnh",
                dataIndex: "userEditName",
                key: "userEditName",
                type: 'text',
                align: 'center'
            },
            {
                title: "Thời gian cập nhật",
                dataIndex: "created",
                key: "created",
                type: 'text',
                align: 'center',
                render:(text,record)=> moment(new Date(text)).format("DD/MM/YYYY HH:mm")

            },
            {
                title: "Giờ vào",
                type: 'text',
                align: 'center',
                children : [
                    {
                        title: 'Cũ',
                        dataIndex: 'gioVaoOld',
                        key: 'gioVaoOld',
                        // render:(text,record) => record.gioVao[0]
                    },
                    {
                        title: 'Mới',
                        dataIndex: 'gioVaoNew',
                        key: 'gioVaoNew',
                        // render:(text,record)=> record.gioVao[1] != "" ? <span style={{color: "red"}}>{record.gioVao[1]}</span> : record.gioVao[0]
                    },
                ]
            },
            {
                title: "Giờ ra",
                align: 'center',
                children : [
                    {
                        title: 'Cũ',
                        dataIndex: 'gioRaOld',
                        key: 'gioRaOld',
                        // render:(text,record)=> record.gioRa[0]
                    },
                    {
                        title: 'Mới',
                        dataIndex: 'gioRaNew',
                        key: 'gioRaNew',
                        // render:(text,record)=> record.gioRa[1] != "" ? <span style={{color: "red"}}>{record.gioRa[1]}</span> : record.gioRa[0]
                    },
                ]
            },
            {
                title: "Ghi chú",
                dataIndex: "ghichu",
                key: "ghichu",
                align: 'center'
            },
        ]

        return (
                <Table
                    dataSource={itemDetail}
                    columns={columns}
                    loading={loadingLs}
                    bordered={true}
                    // scroll={{x:1200}}
                    size={'small'}
                    rowKey="id"
                    // onChange={handleChange}
                    pagination={false}

                />
        )
    }

    const FormViewHisTimekeeping  = ({itemDetail})=>{
        const [pagerLsCC, setPagerLsCC] = useState({pageSize:10, current:1});
        const columnsTimeKeeping = [
            {
                title: "STT",
                dataIndex: "index",
                key: "index",
                align: 'center',
                render: (value, item, index) => ((pagerLsCC.current || 1) - 1) * pagerLsCC.pageSize + index + 1,
            },
            // {
            //     title: "Ngày",
            //     dataIndex: "ngayChamcong",
            //     key: "ngayChamcong",
            //     align: 'center',
            //     render: (text)=> moment(new Date(text)).format("DD/MM/YYYY"),
            // },
            {
                title: "Giờ",
                dataIndex: "gioChamcong",
                key: "gioChamcong",
                align: 'center'
            },
            {
                title: "Thiết bị",
                dataIndex: "thietbiChamcong",
                key: "thietbiChamcong",
                align: 'center'
            },
            {
                title: "Vị trí thiết bị",
                dataIndex: "vitriThietbi",
                key: "vitriThietbi",
                align: 'center'
            },

        ]

        return (

            <Table
                dataSource={itemDetail}
                // @ts-ignore
                columns={columnsTimeKeeping}
                bordered={true}
                // scroll={{x:1200}}
                size={'small'}
                rowKey="id"/>
        )
    }

    return <Modal visible={visible} onCancel={onCancelModal}
            title={<>Chi tiết công - {itemDetail.hasOwnProperty('nhanvien') ? itemDetail.nhanvien.toString() : ''} - {itemDetail.hasOwnProperty('col'+currentDate) && capitalizeFirstWord(moment(itemDetail['col'+currentDate].ngay, 'YYYY-MM-DD').format('dddd, [ngày] DD/MM/YYYY')) }</>}
            style={{minWidth: "700px"}}
                  width={1000}
            footer={false}
            className={itemDetail.hasOwnProperty('col'+currentDate) ? `${getClassColor(itemDetail['col'+currentDate].type)}-modal` : ""}
            bodyStyle={{paddingTop: 6}}
            >
                <Tabs
                    activeKey={activeKey}
                    type="card"
                    tabBarStyle={{display:"none"}}
                >

                    <Tabs.TabPane
                        tab={''}
                        key="1"
                    >
                        <Form form={form} name="control-hooks" onFinish={onFinish} layout={'vertical'}>
                            <Row justify="center">
                                <Col span={11}>
                                    <Form.Item name="gioVao" label="Giờ vào" style={{marginBottom: 6}}>
                                        {isEditing ? <TimePicker
                                            format="HH:mm"
                                            placeholder={"-"}
                                            inputReadOnly={true}
                                            allowClear={false}
                                            value={timeStart}
                                            onSelect={(value)=>{setTimeStart(value);form.setFieldsValue({giovaodangky:value})}}
                                            disabledHours={getDisableHourInEdit}
                                        />:
                                        <Input disabled/>}
                                    </Form.Item>
                                </Col>
                                <Col span={11} offset={2}>
                                        <Form.Item name="gioRa" label="Giờ ra" style={{marginBottom: 6}}>
                                        {isEditing ? <TimePicker
                                            format="HH:mm"
                                            placeholder={"-"}
                                            inputReadOnly={true}
                                            value={timeEnd}
                                            allowClear={false}
                                            onSelect={(value)=>{setTimeEnd(value);form.setFieldsValue({gioradangky:value})}}
                                            disabledHours={getDisableHourOutEdit}
                                        />:
                                        <Input disabled/>}
                                    </Form.Item>
                                </Col>

                            </Row>

                            <Row justify="center">
                                <Col span={11}>
                                    <Form.Item name="soGioCong" label="Số giờ công" style={{marginBottom: 6}}>
                                        <Input disabled bordered={false}/>
                                    </Form.Item>
                                </Col>
                                <Col span={11} offset={2}>
                                    <Form.Item name="soCong" label="Số công" style={{marginBottom: 6}}>
                                        <Input disabled bordered={false}/>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row >
                                <Col span={24}>
                                    <Form.Item name="loaiCC" label="Loại chấm công" style={{marginBottom: 0}}>
                                        <Input disabled bordered={false}/>
                                    </Form.Item>
                                </Col>
                                <Col span={5} className={'mt-3'}>
                                    <Menu
                                        mode="vertical"
                                        expandIcon={<DoubleRightOutlined className="text-link"/>}
                                        style={{borderRight: 0}}
                                        className="text-link"
                                        selectable={false}
                                        >
                                        <Menu.SubMenu
                                            title={<><span className="text-link">Xem lịch sử</span></>}
                                            style={{paddingRight: 0}}
                                        >
                                            <Menu.Item key="1" onClick={viewHistoryTimekeeping}>
                                                <a className="text-link">Chấm công</a>
                                            </Menu.Item>
                                            <Menu.Item key="2" onClick={viewHistoryEdit}>
                                                <a className="text-link">Chỉnh sửa</a>
                                            </Menu.Item>
                                        </Menu.SubMenu>
                                        </Menu>

                                </Col>
                            </Row>

                        </Form>
                    </Tabs.TabPane>

                    <Tabs.TabPane
                        tab={''}
                        key="2"
                    >
                        <Row >
                            <Col span={24} className={'mt-4 mb-4'}>
                                <FormViewHisTimekeeping itemDetail={dataLsCC}></FormViewHisTimekeeping>
                            </Col>
                            <Col span={24} style={{marginBottom: 6}}>
                                <Text italic onClick={()=>setActiveKey('1')} style={{cursor: "pointer"}}><a className="text-link"><DoubleLeftOutlined /> Xem chi tiết công </a></Text>
                            </Col>
                        </Row>
                    </Tabs.TabPane>

                    <Tabs.TabPane
                        tab={''}
                        key="3"
                    >
                        <Row >
                            <Col span={24} className={'mt-4 mb-4'}>
                                <FormViewHistoryEdit itemDetail={dataLs}></FormViewHistoryEdit>
                            </Col>
                            <Col span={24} style={{marginBottom: 6}}>
                                <Text italic onClick={()=>setActiveKey('1')} style={{cursor: "pointer"}}><a className="text-link"><DoubleLeftOutlined /> Xem chi tiết công </a></Text>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                </Tabs>
                {/*<Form.Item {...tailLayout} style={{marginBottom: 0}}>*/}
                {/*    <Button onClick={onEditing}>Chỉnh sửa</Button>*/}
                {/*    <Button onClick={onCancel}>Thoát</Button>*/}
                {/*</Form.Item>*/}
        </Modal>
}

export const BangChamCongChiTietNhanSu =()=>{
    const defaultPageSize = 50;
    const [pager, setPager] = useState({pageSize:defaultPageSize, count: 0, current:1});
    const [data, setData] = useState([]);
    const [lsDate, setLsDate] = useState(getDateRange(moment(new Date())));
    const [statusAll, setStatusAll] = useState(null);
    const [lsTeam, setLsTeam] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [lsMemberId, setLsMemberId] = useState([]);
    const [treeData,setTreeData] = useState([]);
    const [currentTeam, setCurrentTeam] = useState([]);
    const [currentItem, setCurrentItem] = useState({});
    const [currentSelectedDate, setCurrentSelectedDate] = useState(moment(new Date()));
    const [currentDateSelected, setCurrentDateSelected] = useState(null);
    const [columns,setColumns] = useState([]);
    const [isShowDetailItem, setIsShowDetailItem] = useState(false);
    const systemGroup = useSelector((state)=>state.systemInfo.systemGroup);
    const [lsIdChamCong, setLsIdChamCong] = useState([]);
    const [isValid, setIsValid] = useState(true);
    // const [dataLichSuEdit, setDataLichSuEdit] = useState(false);
    const userInfo = useSelector((state)=>state.getUserInfo.userInfo);
    const [lsBoPhan, setLsBoPhan] = useState([]);
    const [currentBoPhan, setCurrentBoPhan] = useState([]);
    const [treeDataBoPhan,setTreeDataBoPhan] = useState([]);
    const [lsAllTeam, setLsAllTeam] = useState([]);
    const [lsAllWeek, setLsAllWeek] = useState([]);
    const [currentWeek, setCurrentWeek] = useState('');
    const [listNgayLe, setListNgayLe] = useState([]);


    const submitApproval = (type) =>{
        if (!isValid) {
            openNotificationWithIcon("error",'Lỗi',"Có dữ liệu không hợp lệ, vui lòng kiểm tra lại");
            return;
        }
        setLoading(true);
        changeStatusCCHRApi({
            type:type,
            listIdHC :JSON.stringify(lsIdChamCong)
        }).then(res=>{
            updateData();
            setLoading(false);
            openNotificationWithIcon('success','Thành công','');
        })
            .catch(err=>{
                errorHandle(err)
                setLoading(false);
            })
    }

    const GetLsButton = ({permissions,systemGroup,status,teamPermissions})=>{
        const maxGroup = new Set(systemGroup.map(item=>item.group)).size
        const BtnPd = ()=> <Button ghost type='success' className={'m-2'} onClick={()=>submitApproval('accept_approval')} icon={<CheckOutlined />}>Phê duyệt</Button>
        const BtnGuiTra = ()=> <Button ghost type='danger' className={'m-2'} onClick={()=>submitApproval('refuse_approval')} icon={<CloseOutlined />}>Gửi trả</Button>

        const arrTeam = teamPermissions.map((item,index)=>item.phanquyen__ten_pq);
        const uniqueArrTeam = [...new Set(arrTeam)];

        let results = []
        if (lsDate.filter(item => moment(currentSelectedDate).month() == moment(item).month()).at(-1) >= new Date()) {
            return results
        }
        switch (maxGroup) {
            case 4: switch (status) {
                case 3: if ((uniqueArrTeam.includes('detailed_timesheet_ns_pd'))){
                            results.push(<BtnPd />)
                        }
                        if ((uniqueArrTeam.includes('detailed_timesheet_ns_reject'))){
                            results.push(<BtnGuiTra />)
                        }
                        break;
            }
        }
        return results.map((item,index)=><span key={index}>{item}</span>)
    }

    const mapDataBCCDetail =(data)=>{
        let results = [];
        let lsMemberId = [];
        let isValid = true;
        let lsIdCCTemp = [];
        for (let i of data) {
            if (i.data.length === 0){
                continue
            }
            lsMemberId.push(i.id)
            let obj = {};
            obj.id = i.id;
            obj.nhanvien = i.msnv + '-' + i.username;
            obj.team = i.team;
            obj.soNgayCong = i.soNgayCong;
            obj.soGioCong = i.soGioCong;
            obj.status = i.status;
            for (let k of i.data) {
                if (k.type === "Error") {
                    isValid = false
                }
                if (k.id !== '') {
                    lsIdCCTemp.push(k.id);
                }
                obj['col' + moment(k.ngay,"YYYY-MM-DD").format("DDMM")] = k;
            }
            results.push(obj);
        }
        setIsValid(isValid)
        setLsIdChamCong(lsIdCCTemp);
        return [results,lsMemberId]
    }
    const getStyleColorOT = (item) =>{
        // console.log(item);
        let result;
        if (item.type === 'Error'){
            result = "#FFCAAF";
        }
        else {
            switch (item.statusId) {
            // case 1:
            case 4:
                result = 'red';
                break;
            case 3:
                result = '#75ef42';
                break;
            case 5:
                result = '#31ecd0';
                break;
            case 6:
                result = '#ec238a';
                break;
            case 2:
                result = '#4ca4f1';break;
            default:
                result = '#ffffff';
                break;
            }
        }

        return result || '';
    }
    const mapColBCCDetail =(data1, listNgayLe)=>{
        let columns_date = [];
        // let ls_date = [];
        // data1.map(({data})=>{
        //     data != [] && data.map((item)=>{
        //         ls_date.push(moment(item.ngay,"YYYY-MM-DD"))
        //     })
        // });
        // const comparisonValues = ls_date.map(v => v.valueOf());
        // ls_date = ls_date.filter((v,i) => comparisonValues.indexOf(v.valueOf()) == i);
        // ls_date.sort((a, b) => a.diff(b));
        for (let [i, value] of lsDate.entries()) {
            const isHoliday = listNgayLe.filter(item=>item.ngay === moment(value).format('YYYY-MM-DD')).length > 0
            let columns_detail = {};
            let currentDate = moment(value).format("DDMM");
            columns_detail['title'] =  getHeader(moment(value),lsDate, isHoliday, currentSelectedDate );
            columns_detail['dataIndex'] = 'col' + currentDate;
            columns_detail['key'] = 'col' + currentDate;
            columns_detail['filterKey'] = 'col' + currentDate;
            columns_detail['type'] = 'text';
            columns_detail['className'] = 'hoverBlur';
            columns_detail['align'] = 'center';
            columns_detail['canSearch'] = true;
            columns_detail['color'] = 'red';
            columns_detail.render = (text,record) => {
                if (moment(currentSelectedDate).month() == moment(value).month()) {
                    return {
                        props: {
                            style:{borderRadius:0,background:record['col' + currentDate] ? getStyleColorOT(record['col' + currentDate]) :"",
                                borderBottom:record['col' + currentDate] && record['col' + currentDate].isEdit ? '2px solid red':''},
                            },
                            children: <div>{RenderItemRow(text,record,updateData,currentDate,setIsShowDetailItem,setCurrentItem,setCurrentDateSelected)}</div>
                    };
                } else {
                    return "";
                }
            };
            columns_date.push(columns_detail);
        }
        const columns_first = [
            // {
            //     title: "STT",
            //     dataIndex: "index",
            //     key: "index",
            //     render: (value, item, index) => ((pager.current || 1) - 1) * pager.pageSize + index + 1,
            //     sortDirections: ['descend', 'ascend', 'descend'],
            // },
            {
                title: "Nhân viên",
                dataIndex: "nhanvien",
                className:'highlight',
                key: "nhanvien",
                filterKey: 'nhanvien',
                type: 'text',
                canSearch: true,
                fixed:'left'
            },
            {
                title: "Team",
                dataIndex: "team",
                className:'highlight',
                key: "team",
                filterKey: 'team',
                type: 'text',
                canSearch: true
            },
        ]

        const columns_last = [
            {
                title: 'Số giờ công',
                dataIndex: "soGioCong",
                key: "soGioCong",
                className:'highlight',
                filterKey: 'soGioCong',
                align:'center',
                type: 'text',
                canSearch: true,
            },
            {
                title: 'Số ngày công',
                dataIndex: "soNgayCong",
                key: "soNgayCong",
                filterKey: 'soNgayCong',
                align:'center',
                type: 'text',
                canSearch: true,
                className:'lastColumn highlight',
            },
            // {
            //     title: 'Trạng thái',
            //     dataIndex: "status",
            //     key: "status",
            //     filterKey: 'status',
            //     align:'center',
            //     type: 'text',
            //     canSearch: true,
            // },
        ]

        let columns = [...columns_first, ...columns_date, ...columns_last]

        return columns
    }

    useEffect(()=>{
        LichLeTetApi({
            nam: moment(currentSelectedDate).year()
        }).then(r=>{
            setListNgayLe(r.data);
        })
    },[])


    const fetchData = async (params = {})=>{
        setLoading(true);
        // debugger
        const lsDateInMonth = params.lsDate.filter(item => moment(currentSelectedDate).month() == moment(item).month());
        nhanSuChiTietCongApi({
            idTeam: JSON.stringify(params.idTeam),
            tuNgay: moment(new Date(lsDateInMonth[0])).format('YYYYMMDD'),
            denNgay: moment(new Date(lsDateInMonth[lsDateInMonth.length - 1])).format('YYYYMMDD'),
            page:params.current,
            page_size:params.pageSize,
            search: params.search
        }).then(r=>{
            const newData = mapDataBCCDetail(r.data.results);
            const newColumns = mapColBCCDetail(r.data.results, listNgayLe);
            let resData = r.data.results.filter(item=>item.statusId !== 0);
            if (resData.length != 0) {
                setStatusAll(Math.min.apply(Math, r.data.results.filter(item=>item.statusId !== 0).map(function(o) { return o.statusId; })))
            } else {
                setStatusAll([0])
            }
            setData(newData[0]);
            setLsMemberId(newData[1]);
            setColumns(newColumns);
            setPager({
                current: params.current,
                pageSize: params.pageSize,
                count: r.data.count
            });
            setLoading(false);
        })
        .catch(err=>{
                errorHandle(err)
                setLoading(false);
            })
    }

    const fetchListTeam = () =>{
        ListBoPhanApi().then(res=>{
            const arrTeam = userInfo.team_permissions.filter(item=>item.phanquyen__ten_pq === 'detailed_timesheet_ns')
                                                    .map((item,index)=>{
                                                        const idBoPhanForTeam = res.data.filter(itemBP =>  itemBP.team.some(itemT => itemT.id==item.team) )
                                                        if (idBoPhanForTeam.length != 0){
                                                            return {idTeam:item.team, team:item.team__tenTeam, idBoPhan: idBoPhanForTeam[0].id}
                                                        }
                                                        return false
                                                    }).filter(item => item != false);
            const uniqueArrTeam = [...new Map(arrTeam.map(item =>[item['idTeam'], item])).values()];
            uniqueArrTeam.sort(function(first, second) {
                return first['idTeam'] - second['idTeam'] ;
              });
            const arrIdTeam = uniqueArrTeam.map(item=>item.idTeam);
            const arrBoPhan = res.data.filter(({team}) => team.some(item => arrIdTeam.includes(item.id)) )
            if (arrBoPhan.length > 0) {
                setCurrentBoPhan([arrBoPhan[0].id]);
            }
            setLsBoPhan(arrBoPhan);

            setLsAllTeam(uniqueArrTeam);
            if (currentTeam.length === 0){
                // setCurrentTeam(arrIdTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x)));
                setCurrentTeam([arrIdTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x))[0]]); // 200423 lấy element đầu tiên đặt trong list
            }
            setLsTeam(uniqueArrTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x.idTeam)) );
        });
    }

    useEffect(()=>{

        if (lsDate.length > 0 && currentTeam.length > 0) {
            fetchData({ idTeam: currentTeam, lsDate: lsDate, ...pager});
        }
        if (currentTeam.length === 0) {
            setData([])
        }
    },[lsDate, currentTeam])

    useEffect(()=>{
        if (userInfo && userInfo.team_permissions && userInfo.team_permissions.length > 0){
            fetchListTeam();
        }
    },[userInfo])

    const updateData=()=>{
        fetchData({idTeam: currentTeam, lsDate: lsDate, ...pager})
    }

    const onChangeBoPhan =(value)=>{
        if (value.length > 0) {
            setCurrentBoPhan(value);
            const lsTeamWith_BP = lsAllTeam.filter(x => value.includes(x.idBoPhan))
            setLsTeam(lsTeamWith_BP);
            setCurrentTeam([lsTeamWith_BP.map(item=>item.idTeam)[0]]); // 200423
        } else {
            setLsTeam([]);
            setCurrentBoPhan([]);
            setCurrentTeam([]);
        };
    }

    const tPropsConfig_BoPhan = {
        treeData:[{
            title:
                currentBoPhan.length > 0 ? (
                <span
                  onClick={() => {if (!loading){onChangeBoPhan([])}}}
                  className="style_SelectTeam"
                >
                  Bỏ chọn tất cả
                </span>
              ) : (
                <span
                  onClick={() => {if (!loading) {onChangeBoPhan(lsBoPhan.map(item=>item.id))}}}
                  className="style_SelectTeam"
                >
                  Chọn tất cả
                </span>
              ),
            value: "xxx",
            disableCheckbox: true,
            disabled: true,
            className: "style_treeTeam"
          },...treeDataBoPhan],
        value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
          onChange:onChangeBoPhan,
        treeCheckable: true,
        // showCheckedStrategy: SHOW_PARENT,
          maxTagCount:2,
        placeholder: 'Chọn bộ phận',
        style:{width:'fit-content',minWidth:200},
        disabled: loading

    };

    useEffect(()=>{
        const treeDataBoPhan = lsBoPhan.map(item=>{return {title: item.tenBophan, value: item.id, key: item.id}})
        setTreeDataBoPhan(treeDataBoPhan);
        if (currentBoPhan.length === 0){
            setCurrentBoPhan(lsBoPhan.map(item=>item.id));
        };
    },[lsBoPhan])

    const onChangeTeam =(value)=>{
        if (value.length > 0) {
            setCurrentTeam(value);
        } else {
            setCurrentTeam([]);
        };
    }

    const onBlurTeamSelect = () => {
        if (currentTeam.length === 0) {
          openNotificationWithIcon("error", "Lỗi", "Vui lòng chọn ít nhất 1 team");
        }
      };

    const tPropsConfig = {
        treeData:[{
            title:
                !loading && currentTeam.length > 0 ? (
                <span
                  onClick={() => setCurrentTeam([])}
                  className="style_SelectTeam"
                >
                  Bỏ chọn tất cả
                </span>
              ) : (
                <span
                  onClick={() => setCurrentTeam(lsTeam.map(item=>item.idTeam))}
                  className="style_SelectTeam"
                >
                  Chọn tất cả
                </span>
              ),
            value: "xxx",
            disableCheckbox: true,
            disabled: true,
            className: "style_treeTeam"
          },...treeData],
        value: treeData.length > 0 ? currentTeam : undefined,
          onChange:onChangeTeam,
        onBlur: onBlurTeamSelect,

        treeCheckable: true,
        // showCheckedStrategy: SHOW_PARENT,
          maxTagCount:2,
        placeholder: 'Chọn team',
        style:{width:'fit-content',minWidth:200},
        disabled: loading
      };

    useEffect(()=>{
        const treeDataTemp = lsTeam.map(item=>{return {title: item.team, value: item.idTeam, key: item.idTeam}})
        setTreeData(treeDataTemp);
        // if (currentTeam.length === 0){
        //     setCurrentTeam(lsTeam.map(item=>item.idTeam));
        // };
        // setCurrentTeam(lsTeam.map(item=>item.idTeam));
    },[lsTeam])

    const onChangeDate =(date)=>{
        // setIsCreate(false)
        setCurrentSelectedDate(date);
        const lsDateTemp = getDateRange(date);
        setLsDate(lsDateTemp);
    };

    useEffect(()=>{
        const arrDay = generateArrWeekAndDays(currentSelectedDate.year(), currentSelectedDate.month()+1);
        setLsAllWeek(arrDay);
        setCurrentWeek(arrDay.filter(item => item.days.some(date => date.isSame(currentSelectedDate, 'date')))[0].name);
    },[currentSelectedDate]);

    const onQuickChangeWeek=(type)=>{
        if (loading){
            return;
        }
        const arrDay = generateArrWeekAndDays(currentSelectedDate.year(), currentSelectedDate.month()+1);
        let lenWeek = 7;
        if (type === 'previous') {
            arrDay.forEach(function (iWeek, index) {
                if (iWeek.days.some(date => date.isSame(currentSelectedDate, 'date'))) {
                    if (index == 0) {
                        arrDay[index].days.length == 7 ? lenWeek = -7 : lenWeek = 0;
                    }else {
                        lenWeek = -arrDay[index-1].days.length;
                    }
                }
            });
        } else {
            arrDay.forEach(function (iWeek, index) {
                if (iWeek.days.some(date => date.isSame(currentSelectedDate, 'date'))) {
                    index == arrDay.length-1 ? lenWeek = arrDay[arrDay.length-1].days.length : lenWeek = 7;
                }
            });
        }
        const numberDay = lenWeek;
        // const numberDay = type === 'previous' ? -7 : 7;
        const newFirstDate = new Date(new Date(lsDate[0]).getTime()+((numberDay)*24*60*60*1000));
        const lsDateTemp = getDateRange(moment(newFirstDate));
        setCurrentSelectedDate(moment(newFirstDate));
        setLsDate(lsDateTemp);

        const arrDayNew = generateArrWeekAndDays(moment(newFirstDate).year(), moment(newFirstDate).month()+1);
        setLsAllWeek(arrDayNew);
        setCurrentWeek(arrDayNew.filter(item => item.days.some(date => date.isSame(moment(newFirstDate), 'date')))[0].name);
    }

    const onChangeSelectWeek = (value) => {
        setCurrentWeek(value)
        const lsAllWeekChange = lsAllWeek.filter(item => item.name == value);
        setCurrentSelectedDate(lsAllWeekChange[0].days[0]);
        const lsDateTemp = getDateRange(lsAllWeekChange[0].days[0]);
        setLsDate(lsDateTemp);
    };

    const handleChange =(pagination)=>{
        const currentPager = {...pager};
        currentPager.current = pagination.current;
        currentPager.pageSize = pagination.pageSize;
        setPager({...currentPager});
        fetchData({
            idTeam: currentTeam,
            lsDate: lsDate,
            status:currentPager.status,
            pageSize:pagination.pageSize,
            current:pagination.current,
            search
        })
    }

    return (
        <>

            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Bảng chấm công chi tiết</h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a>Nhân sự</a>
                                </li>
                                <li className="breadcrumb-item active">Bảng chấm công chi tiết</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className={'col-12 mb-2 d-sm-flex align-items-center justify-content-between'}>
                    <div className={'col'}>
                        <Space align="center" className="space-align-block styleNtn_1" >
                            <Button type="primary" className={'styleNtn_1 addBtnWeek'} onClick={()=>onQuickChangeWeek('previous')} title="Tuần trước">
                                <i className={'fa fa-arrow-left'}></i>
                            </Button>
                            <Select
                                onChange={onChangeSelectWeek}
                                value={currentWeek}
                            >
                                {lsAllWeek.map((item, key) => <Select.Option key={item.name} value={item.name}>{item.name}</Select.Option>)}
                            </Select>

                            <Button type="primary" className={'styleNtn_1 addBtnWeek'} onClick={()=>onQuickChangeWeek('next')} title="Tuần sau">
                                <i className={'fa fa-arrow-right'}></i>
                            </Button>
                        </Space>

                        <DatePicker style={{borderRadius:10}} disabled={loading} className={'m-2'} onChange={onChangeDate} value={currentSelectedDate} format={'DD/MM/YYYY'} allowClear={false}/>

                        <div className="styleBadge">
                            <Badge.Ribbon text="Bộ phận" color="gray" style={{color:"red"}}>
                                <TreeSelect {...tPropsConfig_BoPhan} />
                            </Badge.Ribbon>
                        </div>
                        <div className="styleBadge">
                            <Badge.Ribbon text="Team" color="gray" style={{color:"red"}}>
                                <TreeSelect {...tPropsConfig} />
                            </Badge.Ribbon>
                        </div>
                        {statusAll
                        && userInfo
                        && userInfo.user_permissions
                        && systemGroup
                        && systemGroup.length > 0
                        && currentTeam.length > 0
                        && !loading
                        && <GetLsButton
                            permissions={userInfo.user_permissions}
                            systemGroup={systemGroup}
                            status={statusAll}
                            teamPermissions={userInfo.team_permissions}
                            />}
                    </div>
                    <div>
                        {/*<Button type={'primary'} style={{marginRight:10}} onClick={()=>setIsShowTongSoNgayNghiTrongThang(true)}>Tổng số ngày nghỉ trong tháng</Button>*/}
                        {/*<Button type={'danger'} onClick={()=>setIsShowChinhSuaLichLamViec(true)}>Chỉnh sửa lịch làm việc</Button>*/}
                    </div>
                </div>
            </div>
            <div className="row">
                <Table
                    dataSource={data}
                    columns={columns}
                    loading={loading}
                    bordered={true}
                    scroll={data.length > 0 && {x:1920,y:500}}
                    className={'custom-table-hover style-6'}
                    // scroll={{x:1200}}
                    size={'small'}
                    rowKey="id"
                    onChange={handleChange}
                    pagination={{
                        current: pager.current,
                        pageSize: pager.pageSize,
                        total: pager.count,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ['50', '75', '100']
                    }}
                    // pagination={false}
                />

            </div>
            <div style={{textAlign: "right"}}>
                <Badge>
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "#ffffff", border: "1px solid gray"}} />
                    Trạng thái “Xem xét”, “Chốt công”
                </Badge>
                <Badge >
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "#4ca4f1"}} />
                    Trạng thái “Chờ NPD phê duyệt”
                </Badge>
                <Badge>
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "#75ef42"}}/>
                    Trạng thái “NPD đã phê duyệt”
                </Badge>
                <Badge  >
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "#31ecd0"}}/>
                    Trạng thái “HR đã phê duyệt”
                </Badge>
                <Badge >
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "red"}}/>
                    Trạng thái “NPD không phê duyệt”
                </Badge>
                <Badge >
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "#ec238a"}}/>
                    Trạng thái “HR không phê duyệt”
                </Badge>
            </div>
            <ModalDetailItem
                visible={isShowDetailItem}
                onCancel={()=>setIsShowDetailItem(false)}
                itemDetail={currentItem}
                currentDate={currentDateSelected}
                updateData={updateData}
                // setIsShowHistoryEdit={setIsShowHistoryEdit}
                // setDataLichSuEdit={setDataLichSuEdit}
            />
            {/* <ModalViewHistoryEdit
                visible={isShowHistoryEdit}
                onCancel={()=>setIsShowHistoryEdit(false)}
                itemDetail={dataLichSuEdit}
                currentDate={currentDateSelected}
            /> */}
        </>
    )
}